angular
	.module 'App.Directive'
	.directive 'passwordValidator', () ->
		restrict: 'A'
		require: 'ngModel'
		link: (scope, elem, attrs, ctrl) ->
			ctrl.$validators.minLength = (value) => ctrl.$isEmpty(value) || value.length >= 12
			ctrl.$validators.maxLength = (value) => ctrl.$isEmpty(value) || value.length <= 64
			ctrl.$validators.lowercase = (value) => ctrl.$isEmpty(value) || (/\p{Ll}/u).test(value)
			ctrl.$validators.uppercase = (value) => ctrl.$isEmpty(value) || (/\p{Lu}/u).test(value)
			ctrl.$validators.digit = (value) => ctrl.$isEmpty(value) || (/\d/).test(value)
			ctrl.$validators.symbol = (value) => ctrl.$isEmpty(value) || (/[ !"#$%&\'()*+,\-.\/:;<=>?@[\]^_`{|}~]/).test(value)
